import { Flex, Typography } from '@banhala/ui-kit';
import React from 'react';

type Props = {
  updatedAt: string;
};

export const PopularKeywordHeader = ({ updatedAt }: Props) => {
  return (
    <Flex.Row
      justifyContent="space-between"
      alignItems="center"
      padding={{ horizontal: 16 }}
      height={44}
    >
      {/* 큰 글꼴 설정 기기(Android allowFontScaling)에서 텍스트 확대로 개행되는 것 방지 (ENABLE-1109) */}
      <Typography type="subtitle1" numberOfLines={1}>
        인기 검색어
      </Typography>
      <Typography type="body2" color="content_secondary" numberOfLines={1}>
        {updatedAt}
      </Typography>
    </Flex.Row>
  );
};
